import script from "./EmptySentence.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptySentence.vue?vue&type=script&setup=true&lang=js"

import "./EmptySentence.vue?vue&type=style&index=0&id=629078f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-629078f0"]])

export default __exports__